import React from 'react';

import AbstractCmsElement from './AbstractCmsElement';

export default class CmsElementNavigation extends AbstractCmsElement {
  getHoverStyle = () => {
    const hoverColor = this.getParamValue('textHoverColor', '');
    const hoverBackgroundColor = this.getParamValue('backgroundHoverColor', '');

    if (!hoverColor && !hoverBackgroundColor) {
      return null;
    }

    let css = '#' + this.getMainId() + ' .ms-navigation-child-link:hover { ';
    if (hoverColor) {
      css += 'color: ' + hoverColor + ' !important; ';
    }
    if (hoverBackgroundColor) {
      css += 'background-color: ' + hoverBackgroundColor + ' !important; ';
    }
    css += '}';

    return <style type="text/css" dangerouslySetInnerHTML={{ __html: css }} />;
  };

  render() {
    const fontSize = this.getParamValue('fontSize', '');
    const textColor = this.getParamValue('textColor', '');

    return (
      <ul
        id={this.getMainId()}
        className={'ms-navigation list-unstyled ' + this.getResponsiveClasses() + this.getCssClasses()}
        style={{
          ...this.getBackgroundStyle(),
          fontSize: fontSize ? fontSize + 'px' : undefined,
          color: textColor || undefined,
        }}
      >
        {this.getElementStyle()}
        {this.getHoverStyle()}

        {this.props.children}
      </ul>
    );
  }
}
CmsElementNavigation.defaultProps = {
  index: '0',
};
